import { Account, Company, Maintenance, MaintenanceType, User } from '@interfaces';
import { Equipment } from '../equipments';

export interface WarrantySummary {
  id?: string;
  equipment?: Equipment;
  maintenance?: Maintenance;
  status?: WarrantyStatus;
  startDate?: Date;
  endDate?: Date;
  extendedEndDate?: Date;
  createdAt?: Date;
  updatedAt?: Date;
  count?: WarrantySummaryCount;
}

export interface WarrantySummaryCount {
  equipment: number;
  maintenance: number;
  total: number;
}

export interface Warranty {
  id?: string;
  equipment?: Equipment;
  maintenance?: Maintenance;
  template?: WarrantyTemplate;
  name?: string;
  status?: WarrantyStatus;
  coverageDurationDays?: number;
  startDate?: Date;
  endDate?: Date;
  extendedEndDate?: Date;
  extendedCoverageDurationDays?: number;
  value?: number;
  extendedValue?: number;
  description?: string;
  archived?: boolean;
  createdBy?: User;
  updatedBy?: User;
  createdAt?: Date;
  updatedAt?: Date;
  companies?: Company[];
  company?: Company;
  maintenancesTypes?: MaintenanceType[];
  attachments?: WarrantyAttachment[];
}

export interface WarrantyTemplate {
  id?: string;
  name?: string;
  account?: Account;
  description?: string;
  value?: number;
  type?: WarrantyType;
  coverageDurationDays?: number;
  extendedCoverageDurationDays?: number;
  extendedValue?: number;
  archived?: boolean;
  createdAt?: Date;
  updatedAt?: Date;
  createdBy?: User;
  updatedBy?: User;
  attachments?: WarrantyAttachment[];
  companies?: Company[];
  maintenancesTypes?: MaintenanceType[];
  warranties?: Warranty[];
}

enum WarrantyType {
  maintenances,
  equipments
}


export interface WarrantyAttachment {
  id?: string;
  title?: string;
  size?: number;
  bucketName?: string;
  fileKey?: string;
  createdAt?: Date;
  download?: Download;
}

interface Download {
  expiresAt?: Date;
  signedUrl?: string;
}

export enum WarrantyStatus {
  active = 'active',
  expired = 'expired',
  extended = 'extended',
  future = 'future'
}
